// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"c04eeb2e","787":"67e51275","880":"e5e3c851"}[chunkId] + ".chunk.js";
};